const About_Footer_Data = [
  {
    title: "Company",
    menuItems: [
      {
        url: "../",
        staticLink: true,
        text: "Home",
      },      
      {
        url: "../ai-auto-apply",
        staticLink: true,
        text: "Auto-Apply",
      },
      {
        url: "../ai-cover-letter",
        staticLink: true,
        text: "AI Cover Letters",
      },    
      {
        url: "../ai-resume",
        staticLink: true,
        text: "AI Resumes",
      },      
      {
        url: "../job-search",
        staticLink: true,
        text: "Job Search",
      },      
      {
        url: "../about/",
        staticLink: true,
        text: "About Us",
      },      
      // {
      //   url: "../mission",
      //   staticLink: true,
      //   text: "Our Mission",
      // },
      // {
      //   url: "../contact",
      //   staticLink: true,
      //   text: "Contact Us",
      // },      
    ],
  },  
    {
      title: "My Account",
      menuItems: [
        {
          url: "../signup",
          staticLink: true,
          text: "Create Account",
        },
        {
          url: "../signin",
          staticLink: true,
          text: "Sign In",
        },
        {
          url: "../help/categories/tutorials",
          staticLink: true,
          text: "Tutorials",
        },        
      ],
    },
    {
      title: "Information",
      menuItems: [
        {
          url: "../help/categories/faqs",
          staticLink: true,
          text: "FAQs",
        },                
        {
          url: "../help",
          staticLink: true,
          text: "Help Center & Support",
        },        
        {
          url: "../privacy",
          staticLink: true,
          text: "Privacy Policy",
        },
        {
          url: "../terms",
          staticLink: true,
          text: "Terms & Conditions",
        },
        {
          url: "../resources",
          staticLink: true,
          text: "Resources",
        },
        {
          url: "../affiliates",
          staticLink: true,
          text: "Affiliate Program",
        }
      ],
    },
  ];

  export default About_Footer_Data;